import type { PropsWithChildren } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface ContainerProps {
  className?: string;
  dataTestId?: string;
}

export const Container = ({
  children,
  className,
  dataTestId,
}: PropsWithChildren<ContainerProps>) => (
  <div
    className={classNames("flex flex-col gap-y-6 px-6 py-5", className)}
    data-testid={dataTestId}
  >
    {children}
  </div>
);
